import React from "react"
import { Box, Switch, Typography } from "@mui/material"
import { dsColorNew } from "@palette"
import { AppWebSuppliersAutocomplete } from "@components/Autocomplete"
import useDsRepricingDataInfo from "Pages/DsRepricing/Page/@hooks/useDataInfo"
import { dsRepricingDrawerData, dsRepricingOriginalData } from "Pages/DsRepricing/Page/@signals"
import { enrichFilterIds } from "Pages/DsRepricing/Page/@utils/filterEnrich"

export default function DsRepricingExcludeWebSuppliers() {
	const d = dsRepricingDrawerData.peek()
	const { dataInfo: idsInfo, setDataInfo: setIds } = useDsRepricingDataInfo(d.filterGroupWebSuppliers ?? [])
	const { dataInfo: exclInfo, setDataInfo: setExcl } = useDsRepricingDataInfo(d.filterGroupWebSuppliersExclusion ?? false)

	const isExclusion = exclInfo.value
	const ids = idsInfo.value ?? []

	const updateMode = (checked) => setExcl(checked, 'filterGroupWebSuppliersExclusion')
	const updateIds = (_, opts) => setIds(opts ?? [], 'filterGroupWebSuppliers')

	return (
		<Box>
			<Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
				<Switch checked={isExclusion} onChange={e => updateMode(e.target.checked)} size="small"/>
				<Typography sx={{ fontSize: 14, color: dsColorNew.textDark, fontWeight: 500 }}>
					{isExclusion ? 'Exclude web suppliers' : 'Include web suppliers'}
				</Typography>
			</Box>
			{/* Individual web suppliers, for the same reason as sites:
			    the engine compares against `id_master_web_supplier`, a
			    Price Seeker id, and a group id is not one. */}
			<AppWebSuppliersAutocomplete
				multiple
				label="Web suppliers"
				placeholder={isExclusion ? 'All web suppliers except…' : 'All web suppliers'}
				value={ids.map(o => o?.value ?? o)}
				onChange={updateIds}
				onAjax={options => { enrichFilterIds('filterGroupWebSuppliers', options, dsRepricingDrawerData, dsRepricingOriginalData); return options }}
			/>
		</Box>
	)
}